import Page from '../../components/Page';
import React from 'react';

import Timeline from '../../components/Timeline/Timeline';
import Container from '../../components/Container/Container';

import styles from './OurStory.module.scss';

import {MEMORY_LANE} from '../../config';

const OurStory = () => {
    return (
        <Page title="Нашата история">
            <Container center className={styles.container}>
                <h2>Нашата история</h2>

                <Timeline data={MEMORY_LANE} />
                <h3>... още много години заедно.</h3>
            </Container>
        </Page>
    );
};

export default OurStory;